import { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Switch,
  message,
} from "antd";
import { callCreateUser } from "../../../../config/api";
import { createUser } from "../../../../types/backend";
import { ALL_GENDER } from "../../../../utils/constants/permissions";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { fetchRole } from "../../../../redux/slice/roleSlide";

const AddUser = (props: any): JSX.Element => {
  const dispatch = useAppDispatch();
  const roles = useAppSelector((state) => state.role.result);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(false);
  const handleOk = () => {
    setOpen(true);
  };

  let query = `current=1&pageSize=30`;
  const handleFetchRole = () => {
    dispatch(fetchRole({ query }));
  };

  useEffect(() => {
    handleFetchRole();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFinish = async (values: createUser) => {
    setLoading(true);
    values.status = status;
    const result = await callCreateUser(values);
    if (result.statusCode === 201) {
      setOpen(false);
      await props.handleFetchUser();
      form.resetFields();
      message.success("create user success !");
    } else {
      message.error("create user failed !");
    }
    setLoading(false);
  };

  const onClose = () => {
    setOpen(false);
  };

  const roleSelect = roles.map((item) => {
    return { value: item._id, label: item.name };
  });

  const onChangeStatus = (checked: boolean) => {
    setStatus(checked);
  };

  return (
    <Spin spinning={loading}>
      <Button type="primary" onClick={handleOk} icon={<PlusOutlined />}>
        Thêm mới
      </Button>
      <Modal
        title="Thêm người dùng"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Tạo mới"
        cancelText="Hủy"
        maskClosable={false}
        width={840}
        onCancel={onClose}>
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: "Please enter email" }]}>
                <Input placeholder="Please enter email" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="password"
                label="Password"
                rules={[{ required: true, message: "Please enter password" }]}>
                <Input.Password placeholder="Please enter password" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter Name" }]}>
                <Input placeholder="Please enter name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="date_of_birth"
                label="Date of birth"
                rules={[{ required: true, message: "Please enter age" }]}>
                <DatePicker
                  style={{ width: "100%" }}
                  defaultValue={undefined}
                  format={"DD/MM/YYYY"}
                  placeholder="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="avatar"
                label="Avatar"
                rules={[
                  { required: true, message: "Please enter url avatar" },
                ]}>
                <Input placeholder="Please enter avatar" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="address"
                label="Address"
                rules={[{ required: true, message: "Please enter address" }]}>
                <Input
                  // onChange={(e) => setName(e.target.value)}
                  placeholder="Please enter address"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="gender"
                label="Gender"
                rules={[{ required: true, message: "Please enter gender" }]}>
                <Select defaultValue="" options={ALL_GENDER} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="role"
                label="Role"
                rules={[{ required: true, message: "Please enter role" }]}>
                <Select defaultValue="" options={roleSelect} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                // name="status"
                label="Trạng thái hoạt động"
                rules={[{ required: true, message: "Please enter status" }]}>
                <Switch defaultChecked onChange={onChangeStatus} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Spin>
  );
};

export default AddUser;
